import { makeRoute } from "@/lib/makeRoute";

export const Route = makeRoute("/outils", "fr", "tools");
